import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Zap, CreditCard, ArrowRight, Clock, Flame } from 'lucide-react';
function useCountdown() {
  const [timeLeft, setTimeLeft] = useState(() => {
    const stored = localStorage.getItem('combo_countdown_end');
    if (stored) {
      const diff = Math.max(0, Math.floor((parseInt(stored) - Date.now()) / 1000));
      return diff;
    }
    const end = Date.now() + 24 * 60 * 60 * 1000;
    localStorage.setItem('combo_countdown_end', end.toString());
    return 24 * 60 * 60;
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 0) return 0;
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  return {
    hours,
    minutes,
    seconds
  };
}
export function HeroSection() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <section className="relative bg-matte text-white pt-6 pb-10 overflow-hidden" data-id="element-101">
      {/* Countdown + Discount Bar */}
      <div className="bg-red-600 py-2.5 px-4 text-center mb-6" data-id="element-102">
        <div className="container mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-6" data-id="element-103">
          <div className="flex items-center gap-2" data-id="element-104">
            <Flame className="w-5 h-5 text-yellow-300 animate-pulse" data-id="element-105" />
            <span className="font-black text-white uppercase tracking-wide text-sm" data-id="element-106">
              70% OFF — Oferta termina en:
            </span>
          </div>
          <div className="flex items-center gap-1 font-mono" data-id="element-107">
            <div className="bg-black/30 px-2.5 py-1 text-xl font-black min-w-[48px] text-center" data-id="element-108">
              {String(hours).padStart(2, '0')}
            </div>
            <span className="text-xl font-black" data-id="element-109">:</span>
            <div className="bg-black/30 px-2.5 py-1 text-xl font-black min-w-[48px] text-center" data-id="element-110">
              {String(minutes).padStart(2, '0')}
            </div>
            <span className="text-xl font-black" data-id="element-111">:</span>
            <div className="bg-black/30 px-2.5 py-1 text-xl font-black min-w-[48px] text-center" data-id="element-112">
              {String(seconds).padStart(2, '0')}
            </div>
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-113">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="max-w-4xl mx-auto text-center" data-id="element-114">
          {/* Discount badge */}
          <div className="inline-flex items-center bg-red-600 text-white font-black px-4 py-1.5 mb-4 text-sm uppercase tracking-wider" data-id="element-115">
            <Clock className="w-4 h-4 mr-2" data-id="element-116" /> Descuento 70% por tiempo limitado
          </div>

          <div className="relative mx-auto max-w-sm mb-6" data-id="element-117">
            <img src="https://cdn.magicpatterns.com/uploads/geeQnDy3wQMCydhKCmLHyU/private_openrouter-generated-image-1776135192283.png" alt="Super Combo Carpintería en Aluminio" className="w-full h-auto drop-shadow-2xl" data-id="element-118" />
          </div>

          <h1 className="text-2xl sm:text-3xl md:text-5xl font-black mb-3 leading-tight tracking-tight" data-id="element-119">
            ¿Querés fabricar ventanas y puertas de aluminio y{' '}
            <span className="text-gold" data-id="element-120">cobrar bien</span> desde el primer
            trabajo?
          </h1>

          <h2 className="text-lg md:text-xl font-bold text-silver mb-2" data-id="element-121">
            El sistema completo que te lleva de cero a taller profesional
          </h2>

          <p className="text-base md:text-lg font-medium text-gray-400 mb-6" data-id="element-122">
            6 Tomos + 6 Bonos — 480 páginas — Acceso inmediato
          </p>

          <motion.a href="#pricing" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="inline-flex items-center justify-center bg-gold text-matte font-black text-lg md:text-xl px-8 py-4 shadow-[0_0_30px_rgba(212,160,23,0.5)] hover:shadow-[0_0_40px_rgba(212,160,23,0.7)] transition-all uppercase w-full md:w-auto" data-id="element-123">
            Quiero mi Super Combo Ahora <ArrowRight className="ml-3 w-5 h-5" data-id="element-124" />
          </motion.a>

          <div className="flex flex-wrap justify-center gap-4 md:gap-6 mt-5 text-sm font-medium text-silver" data-id="element-125">
            <div className="flex items-center" data-id="element-126">
              <ShieldCheck className="w-4 h-4 mr-1.5 text-gold" data-id="element-127" /> Garantía 7
              días
            </div>
            <div className="flex items-center" data-id="element-128">
              <Zap className="w-4 h-4 mr-1.5 text-gold" data-id="element-129" /> Acceso inmediato
            </div>
            <div className="flex items-center" data-id="element-130">
              <CreditCard className="w-4 h-4 mr-1.5 text-gold" data-id="element-131" /> Mercado Pago
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}